import { ReactNode } from "react"
import { Nav } from "react-bootstrap"
import HasAccessToRoute from "../../authentication/hasAccessToRoute"
import UserAccessSettings from "../../authentication/UserAccessSettings"
import UserState from "../../authentication/UserState"
import { GetSinglePageAppPath } from "../../BaseUrl"

export interface NavMenuLinkProps {
  title: ReactNode
  route: string
  userAccess: UserAccessSettings
  userState: UserState
}
export interface NavMenuLinkPropsWithNumber {
  title: ReactNode
  route: string
  userAccess: UserAccessSettings
  userState: UserState
  count: number
}

export default function NavMenuLink(props: NavMenuLinkProps) {
  if (!HasAccessToRoute(props.route, props.userAccess, props.userState)) {
    return <></>
  }
  return <Nav.Link href={`${GetSinglePageAppPath()}#${props.route}`}>{props.title}</Nav.Link>
}
export function NavMenuLinkWithNumber(props: NavMenuLinkPropsWithNumber) {
  if (!HasAccessToRoute(props.route, props.userAccess, props.userState)) {
    return <></>
  }
  if (props.count > 0) {
    return <Nav.Link href={`${GetSinglePageAppPath()}#${props.route}`}>{props.title} <span style={{ color: 'red' }}>{props.count}</span></Nav.Link>
  }
  return <Nav.Link href={`${GetSinglePageAppPath()}#${props.route}`}>{props.title}</Nav.Link>

}
